import React from 'react';
import Proptypes from 'prop-types';

const Checkmark = ({ color }) => (
  <svg
    width="180px"
    height="180px"
    style={{ margin: '16px 0px' }}
    viewBox="0 0 180 180"
    version="1.1"
    data-testid="checkmark"
  >
    <g
      id="checkmark"
      stroke="none"
      strokeWidth="1"
      fill={color}
      fillRule="evenodd"
    >
      <g
        id="checkmark-inner"
        transform="translate(-98.000000, -59.000000)"
        stroke="#979797"
      >
        <g id="Group" transform="translate(98.000000, 59.000000)">
          <path
            d="M90,0.5 C114.714743,0.5 137.089743,10.5176287 153.286057,26.7139431 C169.482371,42.9102574 179.5,65.2852574 179.5,90 C179.5,114.714743 169.482371,137.089743 153.286057,153.286057 C137.089743,169.482371 114.714743,179.5 90,179.5 C65.2852574,179.5 42.9102574,169.482371 26.7139431,153.286057 C10.5176287,137.089743 0.5,114.714743 0.5,90 C0.5,65.2852574 10.5176287,42.9102574 26.7139431,26.7139431 C42.9102574,10.5176287 65.2852574,0.5 90,0.5 Z M133.643767,38.5333821 C126.741938,41.1903559 118.941569,46.4825725 110.250755,54.4244723 C101.649847,62.2842141 88.6051595,76.0014503 71.1180658,95.5775922 C59.4821243,90.4341764 52.1051741,87.462291 48.6744492,86.5740625 C47.5382874,86.2676532 45.089933,85.6160351 42.9481721,85.8040624 C41.5200691,85.9294369 40.2384873,86.4274252 39.464409,87.5329119 C38.9555252,88.2596654 38.3135805,90.3533166 38.5532286,92.0691625 C38.8288369,94.0424791 39.8324454,95.7926519 40.2866392,96.578452 C41.0509202,98.2696531 42.6640807,100.049792 45.1927446,102.808294 C46.9376387,104.711787 49.1226393,107.095243 51.7620956,110.269855 C55.1475306,114.341694 61.0096707,123.117357 69.3862919,136.642058 C71.5358405,139.342712 73.0918778,140.538071 73.998692,140.538071 C74.5172226,140.538071 75.1416749,140.219605 75.8324005,139.443677 C76.4010311,138.804905 77.0378855,137.848638 77.7555657,136.53448 C86.8979773,116.052311 95.1639943,100.47462 102.557627,89.8038004 C109.953862,79.1292236 122.575554,64.5618668 140.537517,45.8989464 C141.34851,43.2695734 141.217024,41.5952325 140.427018,40.7399551 C139.673237,39.9238963 137.528284,39.1458739 133.643767,38.5333821 Z"
            id="Combined-Shape"
          ></path>
          <path d="" id="Path"></path>
        </g>
      </g>
    </g>
  </svg>
);

Checkmark.propTypes = {
  color: Proptypes.string
};

Checkmark.defaultProps = {
  color: '#fff'
};

export default Checkmark;
